module.exports = __webpack_public_path__ + "static/img/dg-service.aec5935.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/dg-service.svg
// module id = lAlU
// module chunks = 11